import {HostingBasicInfo} from "./hosting-basic-info";
import {HostingSftp} from "./hosting-sftp";
import {HostingPasswordProtection} from "./hosting-password-protection";
import {HostingDatabase} from "./hosting-database";


export class HostingData {

  public hostingBasicInfo: HostingBasicInfo;
  public hostingSftp: HostingSftp;
  public hostingDatabase: HostingDatabase;
  public hostingPasswordProtection: HostingPasswordProtection;

}

